import "core-js/modules/es.symbol";
import "core-js/modules/es.array.filter";
import "core-js/modules/es.array.find";
import "core-js/modules/es.array.for-each";
import "core-js/modules/es.array.includes";
import "core-js/modules/es.array.splice";
import "core-js/modules/es.date.to-string";
import "core-js/modules/es.object.get-own-property-descriptor";
import "core-js/modules/es.object.get-own-property-descriptors";
import "core-js/modules/es.object.keys";
import "core-js/modules/es.string.includes";
import "core-js/modules/web.dom-collections.for-each";
import _defineProperty from "C:\\Users\\frontend\\Desktop\\Piaf-Vue 2\\Piaf-Vue\\node_modules\\@babel\\runtime-corejs3/helpers/esm/defineProperty";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(source, true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(source).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import { mapGetters, mapActions } from 'vuex';
import ApplicationMenu from "../../../components/Common/ApplicationMenu";
import ContactList from "../../../components/ChatApp/ContactList";
import ConversationList from "../../../components/ChatApp/ConversationList";
import ConversationDetail from "../../../components/ChatApp/ConversationDetail";
export default {
  components: {
    'application-menu': ApplicationMenu,
    'contact-list': ContactList,
    'conversation-list': ConversationList,
    'conversation-detail': ConversationDetail
  },
  data: function data() {
    return {
      tabIndex: 0,
      message: '',
      searchKey: '',
      isLoadCurrentConversation: false,
      otherUser: null,
      conversationMessages: null
    };
  },
  computed: _objectSpread({}, mapGetters(['currentUser', 'isLoadContacts', 'isLoadConversations', 'error', 'contacts', 'contactsSearchResult', 'conversations'])),
  methods: _objectSpread({}, mapActions(['getContacts', 'searchContacts', 'getConversations']), {
    selectConversation: function selectConversation(otherUser, messages) {
      this.otherUser = otherUser;
      this.conversationMessages = messages;
    },
    selectContact: function selectContact(userId) {
      var _this = this;

      this.otherUser = this.contacts.find(function (x) {
        return x.id === userId;
      });
      var conversation = this.conversations.find(function (x) {
        return x.users.includes(userId) && x.users.includes(_this.currentUser.id);
      });

      if (conversation) {
        console.log('change selected conversation');
        this.conversationMessages = conversation.messages;
      } else {
        console.log('create new conversation');
        var date = new Date();
        this.conversations.splice(0, 0, {
          users: [userId, this.currentUser.id],
          messages: [],
          lastMessageTime: date.getHours() + ':' + date.getMinutes()
        });
        this.conversationMessages = [];
      }

      this.tabIndex = 0;
      this.message = '';
      this.searchKey = '';
    },
    sendMessage: function sendMessage() {
      console.log('add message to conversation');
      var date = new Date();
      this.conversationMessages.push({
        sender: this.currentUser.id,
        text: this.message,
        time: date.getHours() + ':' + date.getMinutes()
      });
      this.message = '';
    }
  }),
  mounted: function mounted() {
    this.getContacts({
      userId: this.currentUser.id,
      searchKey: ''
    });
    this.getConversations(this.currentUser.id);
    document.body.classList.add("no-footer");
  },
  beforeDestroy: function beforeDestroy() {
    document.body.classList.remove("no-footer");
  },
  watch: {
    searchKey: function searchKey(val, oldVal) {
      this.searchContacts({
        userId: this.currentUser.id,
        searchKey: val
      });
    }
  }
};